define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/store/_base",
	"csi/store/Names",
	"csi/table/matrix/Path",
	"csi/xml",
	"Apparel/StructureItemMixin"
], function(array,declare,csi,csiStore,Names,PathMatrix,xml,StructureItemMixin) {

	var	STORE_ID = "MaterialThemeMatrix";

	return declare([PathMatrix, StructureItemMixin], {
		addDeferred: function(/*Context*/ctx, /*Heading*/h, /*Deferred[]*/dfds) {
			// summary: add any deferreds necessary to resolve before processing view
			var store = this._getStore(ctx, STORE_ID);
			if (!store) {
				var s = csiStore.searchByType("Theme");
				var q = s.getQuery();
				q.Or()
				    .RefAttr(this._resolveViewRelation(ctx.view), xml.OP_EQUALS, ctx.getNodeURL(), "Parent:Theme")
				    .RefAttr(this._resolveThemeRelation(ctx.view), xml.OP_EQUALS, ctx.getNodeURL());

				store = new Names({
					request: s.getRequest(),
					typeNode: "Theme"
				});

				dfds.push(store.query());
				this._cacheStore(ctx, STORE_ID, store);
			}
		},

		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: remove any themes that are not in current structure
			var	store = this._getStore(ctx, STORE_ID);
			var	obj = csi.hashArray(store.query(), store.idProperty, Boolean);
			return array.filter(nodes, function(node) { return obj[node.$URL]; });
		}
	});
});